module.exports = __webpack_public_path__ + "static/11-1f3f1cb4cb01f0f442da09a72c713826.wav";